const fernFamilyData = [
  {
    id: "fern-01",
    position: [0, 0, 0],
    rotation: [0, 0.2, 0],
    scale: 1.05,
    isMain: true,
  },
  {
    id: "fern-02",
    position: [-0.8, 0, -0.9],
    rotation: [0, -0.6, 0],
    scale: 0.95,
    isMain: false,
  },
  {
    id: "fern-03",
    position: [0.6, 0, -1.2],
    rotation: [0, 0.9, 0],
    scale: 1.1,
    isMain: false,
  },
  {
    id: "fern-04",
    position: [0, 0, -1.5],
    rotation: [0, -1.2, 0],
    scale: 0.88,
    isMain: false,
  },
  {
    id: "fern-05",
    position: [2.5, 0, -1.3],
    rotation: [0, 1.7, 0],
    scale: 0.92,
    isMain: false,
  },
  {
    id: "fern-06",
    position: [-1.2, 0, -2.5],
    rotation: [0, -2.1, 0],
    scale: 1.18,
    isMain: false,
  },
  {
    id: "fern-07",
    position: [2.0, 0, -2.6],
    rotation: [0, 2.4, 0],
    scale: 1.0,
    isMain: false,
  },
  {
    id: "fern-08",
    position: [-1.1, 0, 0.8],
    rotation: [0, -0.25, 0],
    scale: 0.9,
    isMain: false,
  },
  {
    id: "fern-09",
    position: [-3, 0, 0.8],
    rotation: [0, 0, 0],
    scale: 1,
    isMain: false,
  },
  {
    id: "fern-10",
    position: [-2.25, 0, 0.25],
    rotation: [0, 0, 0],
    scale: 0.75,
    isMain: false,
  },
  {
    id: "fern-11",
    position: [-3, 0, -0.8],
    rotation: [0, -0.75, 0],
    scale: 1.3,
    isMain: false,
  },
  {
    id: "fern-12",
    position: [-1.6, 0, -0.8],
    rotation: [0, -0.75, 0],
    scale: 0.75,
    isMain: false,
  },
  {
    id: "fern-13",
    position: [1.0, 0, 0.7],
    rotation: [0, 0.45, 0],
    scale: 0.86,
    isMain: false,
  },
  {
    id: "fern-14",
    position: [1.8, 0, -0.1],
    rotation: [0, 0.85, 0],
    scale: 0.75,
    isMain: false,
  },
  {
    id: "fern-15",
    position: [2.25, 0, 3.15],
    rotation: [0, 0.85, 0],
    scale: 1.1,
    isMain: false,
  },
  {
    id: "fern-16",
    position: [-0.25, 0, 3.7],
    rotation: [0, 0, 0],
    scale: 0.75,
    isMain: false,
  },
  {
    id: "fern-17",
    position: [-1, 0, 3.7],
    rotation: [0, 0.75, 0],
    scale: 0.5,
    isMain: false,
  },
  {
    id: "fern-18",
    position: [-2.85, 0, -3.5],
    rotation: [0, 0.55, 0],
    scale: 1,
    isMain: false,
  },
  {
    id: "fern-19",
    position: [-5, 0, -4.3],
    rotation: [0, 0.55, 0],
    scale: 0.75,
    isMain: false,
  },
];

export default fernFamilyData;